import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-pa-sm q-mb-md bg-neutral" }

import { computed } from "vue";
import { appStore, useScreen } from "@/hooks";
import { DeltaPanel } from "@/components/delta/panel";
import { ViewPanel } from "@/components/view";
import {
  ArtifactPanel,
  ArtifactBodyPanel,
  HealthPanel,
  SaveArtifactPanel,
  ArtifactGenerationPanel,
  ArtifactSummarizationPanel,
} from "@/components/artifact/panel";
import {
  TraceLinkPanel,
  SaveTraceLinkPanel,
  GenerateTraceLinkPanel,
  EditTraceLinkPanel,
} from "@/components/traceLink/panels";
import {
  ArtifactLevelPanel,
  SaveArtifactLevelPanel,
} from "@/components/artifactType";
import { TraceMatrixPanel } from "@/components/traceMatrix";
import { ProjectOverviewPanel } from "@/components/project/panel";


/**
 * Renders content in a right side panel.
 */
const __default__ = {
  name: "DetailsDrawer",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

const openState = computed(() => appStore.popups.detailsPanel);
const drawerOpen = computed(() => typeof openState.value === "string");

const className = computed(
  () => `bg-neutral nav-panel nav-panel-${openState.value}`
);

const width = computed(() => {
  if (smallWindow.value) {
    return 500;
  } else if (
    openState.value === "displayArtifactLevel" ||
    openState.value === "displayTraceMatrix" ||
    openState.value === "displayTrace" ||
    openState.value === "displayArtifact" ||
    openState.value === "saveArtifact"
  ) {
    return 600;
  } else if (
    openState.value === "displayArtifactBody" ||
    openState.value === "generateTrace" ||
    openState.value === "displayProject"
  ) {
    return 800;
  } else {
    return 500;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_drawer = _resolveComponent("q-drawer")!

  return (_openBlock(), _createBlock(_component_q_drawer, {
    breakpoint: 500,
    class: _normalizeClass(className.value),
    "model-value": drawerOpen.value,
    width: width.value,
    bordered: "",
    side: "right"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(DeltaPanel)),
        _createVNode(_unref(ViewPanel)),
        _createVNode(_unref(ProjectOverviewPanel)),
        _createVNode(_unref(ArtifactPanel)),
        _createVNode(_unref(ArtifactBodyPanel)),
        _createVNode(_unref(SaveArtifactPanel)),
        _createVNode(_unref(TraceLinkPanel)),
        _createVNode(_unref(SaveTraceLinkPanel)),
        _createVNode(_unref(EditTraceLinkPanel)),
        _createVNode(_unref(ArtifactLevelPanel)),
        _createVNode(_unref(SaveArtifactLevelPanel)),
        _createVNode(_unref(TraceMatrixPanel)),
        _createVNode(_unref(GenerateTraceLinkPanel)),
        _createVNode(_unref(ArtifactGenerationPanel)),
        _createVNode(_unref(HealthPanel)),
        _createVNode(_unref(ArtifactSummarizationPanel))
      ])
    ]),
    _: 1
  }, 8, ["class", "model-value", "width"]))
}
}

})